import React from 'react';
import { observer } from 'mobx-react';
import { useClientStore } from 'apps/hooks';

import { Divisor, Button, Box, Loading, Heading } from 'components';
import { useAppManager } from 'core/hooks';

import { MainWrapper } from 'legacyComponents/styled/lib';
import DocumentHead from 'legacyComponents/documentHead';

import { ShippingInfo } from 'apps/shared';
import { formatDate } from 'utils/formatStrings';
import { FourOhFour } from 'apps/fourOhFour/index';
import { QuotePagePriceBreakdown } from './QuotePagePriceBreakdown';
import { ProductQuotesTable } from './ProductQuotesTable';
import QuotePageAppManager from './appManager';
import { Terms } from './Terms';
import { Miscellaneous } from '../Miscellaneous';
import { ShipmentQuoteDetails } from './ShipmentQuoteDetails';
import { QuotePageHeader } from './QuotePageHeader';
import { Notes } from './Notes';
import { ExpirationBanner } from './ExpirationBanner';

export const QuotePage = observer(function QuotePage() {
  const clientStore = useClientStore();
  const isIntermediator = clientStore.currentPortal === 'INTERMEDIATOR';
  const quoteAppManager = useAppManager(QuotePageAppManager);
  const { quote } = quoteAppManager;
  const handlePay = () => {
    quoteAppManager.PayQuote();
  };

  if (quoteAppManager.loading) return <Loading />;
  if (quoteAppManager.notFound) {
    return <FourOhFour />;
  }

  const isPaymentDisabled = quote.isExpired;
  const isPayButtonLoading = quoteAppManager.isCheckoutInitiated;

  return (
    <MainWrapper marginTop='2rem'>
      <DocumentHead title='Quote' />
      <QuotePageHeader
        quote={quote}
        quoteAppManager={quoteAppManager}
        isPayButtonLoading={isPayButtonLoading}
      />
      <ExpirationBanner
        isExpired={quote.isExpired}
        daysRemaining={quote.daysRemaining}
      />
      <ShipmentQuoteDetails quote={quote} />
      <ProductQuotesTable productQuotes={quote?.productQuotes.apps} />
      <Miscellaneous quote={quote} disableActions={true} />
      <Box mt={8} sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
          }}
        >
          <QuotePagePriceBreakdown quote={quote} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
          }}
        >
          <ShippingInfo address={quote.address} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
          }}
        >
          <Notes notes={quote.notes} />
        </Box>
      </Box>
      <Box mt={8} sx={{ textAlign: 'center' }}>
        <Button
          margin='0 0 16px 0'
          data-test-id='quote-pay-now-button'
          onClick={handlePay}
          loading={isPayButtonLoading}
          text='Pay Now'
          disabled={isPaymentDisabled}
          icon='arrow_right'
          iconPosition='right'
        />
      </Box>
      <Heading level={5} align='center'>
        Pay Now to receive by {formatDate(quote.deliveryDate)}
      </Heading>
      {!isIntermediator && (
        <>
          <Divisor sx={{ marginTop: 32, marginBottom: 32 }} />
          <Terms quote={quote} />
          {/* <Box sx={{ textAlign: 'center' }}>
            <Button text='Pay Now' margin='24px auto' onClick={handlePay} />
          </Box> */}
        </>
      )}
    </MainWrapper>
  );
});
